import * as React from 'react'

import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import { LocalizationProvider } from '@mui/x-date-pickers-pro'
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs'
import { DateRangePicker as MuiDateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker'

export default function DateRangePicker({
  onChange = () => {},
  value: initialValue = [null, null],
}) {
  const [value, setValue] = React.useState(initialValue ?? [null, null])

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      localeText={{ start: 'Start Date', end: 'End Date' }}
    >
      <MuiDateRangePicker
        value={value}
        onChange={(newValue) => {
          onChange(newValue)
          setValue(newValue)
        }}
        inputFormat="MM/DD/YYYY"
        renderInput={(startProps, endProps) => (
          <React.Fragment>
            <TextField
              {...startProps}
              size="small"
              sx={{
                '& input': {
                  py: 1.25,
                },
              }}
            />
            <Box sx={{ mx: 2 }}> to </Box>
            <TextField
              {...endProps}
              size="small"
              sx={{
                '& input': {
                  py: 1.25,
                },
              }}
            />
          </React.Fragment>
        )}
      />
    </LocalizationProvider>
  )
}
